import { Disclosure } from '@headlessui/react'
import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import { useState} from 'react';

//https://contactmentor.com/checkbox-list-react-js-example/
const filters = {
  buildingType: [
    { value: 'Public', label: '公屋', checked: false },
    { value: 'Estate', label: '居屋', checked: false },
    { value: 'Private', label: '私樓', checked: false },
    { value: 'Others', label: '其他', checked: false },
  ],
  style1: [
    { value: 'Y2', label: 'Y2型 (公屋/居屋)', checked: false },
    { value: 'Y3', label: 'Y3型 (公屋/居屋)', checked: false },
    { value: 'Y4', label: 'Y4型 (公屋/居屋)', checked: false },
    { value: 'NCB', label: '新十字型 (居屋)', checked: false },
    { value: 'CB', label: '康和式 (居屋)', checked: false },
    { value: 'HR', label: '和諧式 (居屋)', checked: false },
  ],
  style2: [
    { value: 'LB', label: '相連長型 (公屋)', checked: false },
    { value: 'OS', label: '長型或新長型 (公屋)', checked: false },
    { value: 'SORDHB', label: '單或雙工字型 (公屋)', checked: false },
    { value: 'TT', label: '雙塔式 (公屋)', checked: false },
    { value: 'NSBD', label: '非標準型 (公屋)', checked: false },
    { value: 'Others', label: '其他', checked: false },
  ],
  featured:[
    { value: 1, label: '精選', checked: false },
  ]
}
const ProductListCategory2 = (props) => {
  const [buildingTypeChecked, setBuildingTypeChecked] = useState([]);
  const [styleChecked, setStyleChecked] = useState([]);
  const [featureChecked, setFeatureChecked] = useState([]);

  function handleSubmitClick(){
    var result = {
      "projectBuildingType": buildingTypeChecked,
      "projectBuildingStyle": styleChecked,
      "hasFeatured": featureChecked,
    }
    props.setSearch(result);
    result = null;
    setBuildingTypeChecked([]);
    setStyleChecked([]);
    setFeatureChecked([]);
  }

  const handleFeatureCheck = (event) => {
    var updatedList = [...featureChecked];
    if(event.target.checked){
      updatedList = [...featureChecked,  parseInt(event.target.value)]
    }else{
      updatedList.splice(featureChecked.indexOf(event.target.value), 1)
    }
    setFeatureChecked(updatedList);
  }

  const handleBuildingTypeCheck = (event) => {
    var updatedList = [...buildingTypeChecked];
    if(event.target.checked){
      updatedList = [...buildingTypeChecked, event.target.value]
    }else{
      updatedList.splice(buildingTypeChecked.indexOf(event.target.value), 1)
    }
    setBuildingTypeChecked(updatedList);
  }

  const handleStyleCheck = (event) => {
    var updatedList = [...styleChecked];
    if(event.target.checked){
      updatedList = [...styleChecked, event.target.value]
    }else{
      updatedList.splice(styleChecked.indexOf(event.target.value), 1)
    }
    setStyleChecked(updatedList);
  }


  return (
    <div className="bg-white">
      {/* Filters */}
      <Disclosure
        as="section"
        aria-labelledby="filter-heading"
        className="relative z-10 border-t border-b border-gray-200 grid items-center"
      >
        <h2 id="filter-heading" className="sr-only">
          Filters
        </h2>
        <div className="relative col-start-1 row-start-1 py-4">
          <div className="max-w-7xl mx-auto flex space-x-6 divide-x divide-gray-200 text-sm px-4 sm:px-6 lg:px-8">
            <div>
              <Disclosure.Button className="group text-gray-700 font-medium flex items-center">
                <FunnelIcon
                  className="flex-none w-5 h-5 mr-2 text-gray-400 group-hover:text-gray-500"
                  aria-hidden="true"
                />
                （打開/關閉） 搜索分類
              </Disclosure.Button>
            </div>
          </div>
        </div>
        <Disclosure.Panel className="border-t border-gray-200 py-10">
          <div className="max-w-7xl mx-auto grid grid-cols-2 gap-x-4 px-4 text-sm sm:px-6 md:gap-x-6 lg:px-8">
            <div className="grid grid-cols-1 gap-y-10 auto-rows-min md:grid-cols-2 md:gap-x-6">
              <fieldset>
                <legend className="block font-medium"><b>屋苑分類</b></legend>
                <div className="pt-6 space-y-6 sm:pt-4 sm:space-y-4">
                  {filters.buildingType.map((option, optionIdx) => (
                    <div key={option.value} className="flex items-center text-base sm:text-sm">
                      <input
                        id={`area-${optionIdx}`}
                        name="area[]"
                        defaultValue={option.value}
                        type="checkbox"
                        className="flex-shrink-0 h-4 w-4 border-gray-300 rounded text-cyan-900 focus:ring-cyan-600"
                        defaultChecked={option.checked}
                        onClick={handleBuildingTypeCheck}
                      />
                      <label htmlFor={`area-${optionIdx}`} className="ml-3 min-w-0 flex-1 text-gray-600">
                        {option.label}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
              <fieldset>
                <legend className="block font-medium"><b>建築分類</b></legend>
                <div className="pt-6 space-y-6 sm:pt-4 sm:space-y-4">
                  {filters.style1.map((option, optionIdx) => (
                    <div key={option.value} className="flex items-center text-base sm:text-sm">
                      <input
                        id={`style-${optionIdx}`}
                        name="style[]"
                        defaultValue={option.value}
                        type="checkbox"
                        className="flex-shrink-0 h-4 w-4 border-gray-300 rounded text-cyan-900 focus:ring-cyan-600"
                        defaultChecked={option.checked}
                        onClick={handleStyleCheck}
                      />
                      <label htmlFor={`style-${optionIdx}`} className="ml-3 min-w-0 flex-1 text-gray-600">
                        {option.label}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
            </div>
            <div className="grid grid-cols-1 gap-y-10 auto-rows-min md:grid-cols-2 md:gap-x-6">
              <fieldset>
                <legend className="block font-medium"><b></b> </legend>
                <div className="pt-6 space-y-6 sm:pt-4 sm:space-y-4 mt-4">
                  {filters.style2.map((option, optionIdx) => (
                    <div key={option.value} className="flex items-center text-base sm:text-sm">
                      <input
                        id={`buildingType-${optionIdx}`}
                        name="buildingType[]"
                        defaultValue={option.value}
                        type="checkbox"
                        className="flex-shrink-0 h-4 w-4 border-gray-300 rounded text-cyan-900 focus:ring-cyan-600"
                        defaultChecked={option.checked}
                        onClick={handleStyleCheck}
                      />
                      <label htmlFor={`buildingType-${optionIdx}`} className="ml-3 min-w-0 flex-1 text-gray-600">
                        {option.label}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>

              <fieldset>
                <legend className="block font-medium"><b>是否精選</b></legend>
                <div className="pt-6 space-y-6 sm:pt-4 sm:space-y-4">
                  {filters.featured.map((option, optionIdx) => (
                    <div key={option.value} className="flex items-center text-base sm:text-sm">
                      <input
                        id={`featured-${optionIdx}`}
                        name="featured[]"
                        defaultValue={option.value}
                        type="checkbox"
                        className="flex-shrink-0 h-4 w-4 border-gray-300 rounded text-cyan-900 focus:ring-cyan-600"
                        defaultChecked={option.checked}
                        onClick={handleFeatureCheck}
                      />
                      <label htmlFor={`featured-${optionIdx}`} className="ml-3 min-w-0 flex-1 text-gray-600">
                        {option.label}
                      </label>
                    </div>
                  ))}
                </div>
              </fieldset>
              
            </div>
          </div>

          <div className="col-start-1 row-start-1 py-4">
            <div className="flex justify-end max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <Disclosure.Button onClick={handleSubmitClick} className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-cyan-900 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500">
                <MagnifyingGlassIcon className="-ml-1 mr-2 h-5 w-5" aria-hidden="true" />
                搜尋作品
              </Disclosure.Button>
            </div>
          </div>
        </Disclosure.Panel>


      </Disclosure>

    </div>
  )
}


export default ProductListCategory2;